import { luckyBirdCodeStatus } from 'utils/hooks/luckyBirdCodeStatus'
import { useCurrentUser } from 'utils/hooks/useCurrentUser'

export const useLBCodeStatus = () => {
  const user = useCurrentUser()
  return (status: keyof typeof luckyBirdCodeStatus) => luckyBirdCodeStatus[status] === user?.lucky_bird_code_status
}
